import AbstractBasicController from "./AbstractBasicController";
import SongChangeEvent from "../event/SongChangeEvent";

class MediaSessionController extends AbstractBasicController {
    /** @inheritDoc */
    constructor(config = {}) {
        super(config);
        this.bindEvents();
    }

    /** Bind the controller's watched events */
    bindEvents() {
        const _self = this;

        if ('mediaSession' in navigator) {
            SongChangeEvent.getInstance().bind(
                /** @param {SongChangeEventData} evData */
                evData => {
                    _self.update( SongChangeEvent.getSong(evData) );
                }
            );
        }
    }

    /**
     * Update the song's information
     * @param {Song} song
     */
    update(song) {
        navigator.mediaSession.metadata = new MediaMetadata({
            title: `${song.album} | ${song.title}`,
            artist: song.artist,
            artwork: [{ src: song.art }]
		});
		navigator.mediaSession.setPositionState({
			duration: Infinity
		})
    }
}

export default MediaSessionController;